<template>
  <div>
    <Banner type="part" />
    <div class="page-container j-container-box-shadow container">
      <div class="title">
        <div class="j-title">{{ partName ? $t(partName) : '' }}</div>
        <a-divider type="vertical" style="margin: 0 40px; height: 30px;" />
        <div>
          <span class="model-label">{{ $t('diagram.model_label') }} : </span>
          <span>{{ model || '' }}</span>
        </div>
      </div>

      <a-divider style="margin: 30px 0;" />

      <a-spin :spinning="loading">
        <div>
          <div class="diagram-container" v-if="diagrams.length > 0">
            <a-row :gutter="[45, 45]">
              <a-col :xs="24" :md="6" v-for="item in diagrams" :key="item.id">
                <DiagramItem
                  :pre-page-no="pageNo"
                  :item="item"
                  :vehicleId="vehicleId"
                />
              </a-col>
            </a-row>
          </div>
          <div class="j-no-result" v-if="loaded && diagrams.length === 0">
            <img
              alt="no-data"
              src="@/assets/images/noData.png"
              width="164"
              height="141"
            />
            <span class="no-data-msg j-content">
              {{ $t('common.coming_soon') }}
            </span>
          </div>
        </div>
      </a-spin>

      <div class="pagination-container" v-if="diagrams.length > 0">
        <a-pagination
          v-model:current="pageNo"
          :page-size-options="pageSizeOptions"
          :total="total"
          show-size-changer
          v-model:pageSize="pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
          show-quick-jumper
        >
          <template #buildOptionText="props">
            <span>{{ props.value }} {{ $t('common.page_per_item_text') }}</span>
          </template>
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { getPartList } from '@/api/apis';
import DiagramItem from './DiagramItem.vue';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'Diagram',
  components: {
    DiagramItem,
    Banner
  },
  data() {
    return {
      loading: false,
      loaded: false,
      diagrams: [],
      pageNo: 1,
      pageSize: 8,
      pageSizeOptions: ['8', '16'],
      current: 1,
      total: 0,
      // params & query
      cataId: 0,
      model: '',
      vehicleId: 0,
      partName: ''
    };
  },
  created() {
    const route = useRoute();

    const params = route.params;

    const query = route.query;

    const pageNo = localStorage.getItem('diagramPageNo') || '';

    if (pageNo && !isNaN(+pageNo)) {
      this.pageNo = +pageNo || 1;
      localStorage.removeItem('diagramPageNo');
    }

    this.model = query.model as string;

    this.partName = query.partName as string;

    if (params.vehicleId && params.cataId) {
      this.cataId = Number(params.cataId);

      this.vehicleId = Number(params.vehicleId);

      if (this.cataId > 0 && this.vehicleId > 0) {
        this.loadData();
      }
    }
  },
  methods: {
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;

      const res = await getPartList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        vehicleId: this.vehicleId,
        parentId: this.cataId,
        type: 2 // 图组
      });

      if (res.success) {
        const data = res.result || {};

        this.diagrams = data.records || [];

        this.total = data.total;
      }

      this.loading = false;

      this.loaded = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  background-color: white;

  .title {
    padding: 32px 0 0 0;
    display: flex;
    align-items: center;
    color: $primary-color;
  }

  .pagination-container {
    padding: 38px 0 40px 0;
    text-align: right;
  }

  .sub-title {
    padding: 30px 0;
    display: block;
  }
}
</style>
